// src/constants/avatarStyles.js
export const avatarStyles = [
  { icon: "user",           color: "#1e88e5", bg: "#e3f2fd", label: "Classic Blue" },
  { icon: "user-tie",       color: "#d81b60", bg: "#fce4ec", label: "Professional" },
  { icon: "user-graduate",  color: "#388e3c", bg: "#e8f5e9", label: "Student" },
  { icon: "user-ninja",     color: "#000000", bg: "#dbdbdb", label: "Ninja" },
  { icon: "user-secret",    color: "#8e24aa", bg: "#f3e5f5", label: "Mystery" },
  { icon: "user-astronaut", color: "#0288d1", bg: "#e1f5fe", label: "Astronaut" },
  { icon: "robot",          color: "#607d8b", bg: "#eceff1", label: "Robot" },
  { icon: "cat",            color: "#f06292", bg: "#fce4ec", label: "Cat Lover" },
  { icon: "dog",            color: "#ff9800", bg: "#fff3e0", label: "Dog Person" },
  { icon: "kiwi-bird",      color: "#4caf50", bg: "#e8f5e9", label: "Bird" },
  { icon: "crown",          color: "#ffb300", bg: "#fff8e1", label: "Royal" },
  { icon: "fish",           color: "#2f76d3", bg: "#ebfbff", label: "Fish" },
  { icon: "motorcycle",     color: "#673ab7", bg: "#ede7f6", label: "Motorcycle" },
  { icon: "snowman",        color: "#00bcd4", bg: "#e0f7fa", label: "Winter" },
  { icon: "heart",          color: "#e91e63", bg: "#fce4ec", label: "Romantic" },
  { icon: "star",           color: "#ffca28", bg: "#fffde7", label: "Star" },
  { icon: "bolt",           color: "#fdd835", bg: "#fffde7", label: "Energy" },
  { icon: "gem",            color: "#9c27b0", bg: "#f3e5f5", label: "Gem" },
  { icon: "fire",           color: "#f44336", bg: "#ffebee", label: "Fire" },
  { icon: "rocket",         color: "#ff5722", bg: "#fbe9e7", label: "Rocket" },
  { icon: "meteor",         color: "#ff9800", bg: "#fff3e0", label: "Meteor" },
  { icon: "sun",            color: "#ffeb3b", bg: "#fffde7", label: "Sunny" },
  { icon: "moon",           color: "#455a64", bg: "#eceff1", label: "Moon" },
  { icon: "cloud",          color: "#90a4ae", bg: "#eceff1", label: "Cloud" },
  { icon: "tree",           color: "#4caf50", bg: "#e8f5e9", label: "Nature" },
  { icon: "leaf",           color: "#66bb6a", bg: "#e8f5e9", label: "Leaf" },
  { icon: "bowl-rice",      color: "#146ebe", bg: "#ffffff", label: "Rice Bowl" },
  { icon: "burger",         color: "#ff7043", bg: "#fbe9e7", label: "Burger" },
  { icon: "ice-cream",      color: "#ec407a", bg: "#fce4ec", label: "Ice Cream" },
  { icon: "coffee",         color: "#6d4c41", bg: "#efebe9", label: "Coffee" },
];